import React from 'react';
import './styles.css';

interface PageLayoutProps {
  /**
   * Page title displayed in the header
   */
  title: React.ReactNode;
  
  /**
   * Actions to display in the header (e.g. buttons)
   */
  actions?: React.ReactNode;
  
  /**
   * Additional content to display below the header
   */
  headerContent?: React.ReactNode;
  
  /**
   * Main content of the page
   */
  children: React.ReactNode;
  
  /**
   * Whether to use fluid width layout
   */
  fluid?: boolean;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  actions,
  headerContent,
  children,
  fluid = false,
}) => {
  return (
    <div className={`page-container ${fluid ? 'page-container-fluid' : ''}`}>
      <div className="page">
        <header className="page-header">
          <div className="page-header-main">
            <h1>{title}</h1>
            {actions && <div className="page-actions">{actions}</div>}
          </div>
          {headerContent && (
            <div className="page-header-content">{headerContent}</div>
          )}
        </header>
        <div className={`page-content ${fluid ? 'page-content-fluid' : ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayout; 